import React from 'react';
import cx from 'classnames';

import Text from '../Text';

import styles from './RegistrationStatusTag.module.scss';
import usePresenter from './RegistrationStatusTag.presenter';
import getProps from './RegistrationStatusTag.props';
import { RegistrationStatusTagCombinedProps } from './types';


const RegistrationStatusTag: React.FC<RegistrationStatusTagCombinedProps> = (props) => {
  const {
    type,
    className,
    classes,
    text,
  } = usePresenter(props);

  const variantName = `${type}`;
  const internalProps = getProps(variantName);
  const currentStyle = styles[`registrationStatusTag${variantName}`];

  let componentView;

  switch (variantName) {
    case 'Closed':
    case 'Open': {
      componentView = (
        <div className={cx(currentStyle, className)}>
          <Text
            className={cx(styles.text, classes?.text)}
            {...internalProps.text}
            {...text}/>
        </div>
      );
      break;
    }
    default:
      componentView = <div>�</div>;
      break;
  }

  return componentView;
};

export default RegistrationStatusTag;

